import { changeExperiment, forceArmFallback } from '$lib/services/experiments';
import {
	AOFL_LEGACY_ROLES,
	AOFL_2_0_ROLES
} from '$lib/utils/constants';

/**
 * Checks if the user is an ABCmouse legacy user in the 2.0 experiment arm.
 * @param {number[]} roles - The roles of the user.
 * @returns {boolean} - True if the user is an ABCmouse legacy user in the 2.0 experiment arm, false otherwise.
 */
export const isAbcmouseLegacyUserIn2_0 = (roles) => {
	for (const key in roles) {
		if (Object.prototype.hasOwnProperty.call(AOFL_LEGACY_ROLES, roles[key])) {
			return true;
		}
	}
	return false;
};

/**
 * Checks if the user is an 2.0 ABCmouse user.
 * @param {number[]} roles - The roles of the user.
 * @returns {boolean} - True if the user is an 2.0 ABCmouse user, false otherwise.
 */
export const isAbcmouseUserIn2_0 = (roles) => {
	for (const key in roles) {
		if (Object.prototype.hasOwnProperty.call(AOFL_2_0_ROLES, roles[key])) {
			return true;
		}
	}
	return false;
};


/**
 * Switches the experiment to match the user's state based on the provided arms.
 * @param {string} fromArm - The ID of the experiment arm to switch from.
 * @param {string} toArm - The ID of the experiment arm to switch to.
 */
export const switchExperimentToMatchUserState = async (fromArm, toArm) => {
	const didChangeExperiment = await changeExperiment(fromArm, toArm, { force: true });
	if (!didChangeExperiment) await forceArmFallback(toArm);
};